import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface LegalSection {
  heading: string;
  paragraphs: string[];
}
interface LegalPageProps {
  language: 'en' | 'es';
  title: string;
  lastUpdated: string;
  sections: LegalSection[];
}
export function LegalPage({
  language,
  title,
  lastUpdated,
  sections
}: LegalPageProps) {
  const backText = language === 'en' ? '← Back to Home' : '← Regresar al Inicio';
  const updatedLabel = language === 'en' ? 'Last Updated' : 'Última Actualización';
  return <div className="min-h-screen bg-obsidian text-warmWhite" data-id="element-190">
      <div className="max-w-[800px] mx-auto px-6 py-16 md:py-20" data-id="element-191">
        <Link to="/" className="inline-flex items-center gap-2 font-montserrat text-gold text-sm font-bold tracking-wide hover:text-yellow-500 transition-colors mb-10" data-id="element-192">
          <ArrowLeftIcon size={16} data-id="element-193" />
          {backText}
        </Link>

        <h1 className="font-oswald text-3xl sm:text-4xl md:text-5xl font-bold text-gold uppercase mb-3" data-id="element-194">
          {title}
        </h1>
        <p className="font-inter text-warmWhite/40 text-sm mb-10" data-id="element-195">
          {updatedLabel}: {lastUpdated}
        </p>

        <div className="space-y-8" data-id="element-196">
          {sections.map((section, i) => <div key={i} data-id="element-197">
              <h2 className="font-oswald text-lg md:text-xl font-bold text-gold uppercase mb-3" data-id="element-198">
                {section.heading}
              </h2>
              {section.paragraphs.map((p, j) => <p key={j} className="font-inter text-warmWhite/80 text-[15px] leading-[1.8] mb-3" data-id="element-199">
                  {p}
                </p>)}
            </div>)}
        </div>

        <div className="mt-12 pt-6 border-t border-steel" data-id="element-200">
          <Link to="/" className="inline-flex items-center gap-2 font-montserrat text-gold text-sm font-bold tracking-wide hover:text-yellow-500 transition-colors" data-id="element-201">
            <ArrowLeftIcon size={16} data-id="element-202" />
            {backText}
          </Link>
        </div>
      </div>
    </div>;
}